import React, {Suspense, lazy} from 'react';
import { Switch, Route } from 'react-router-dom';
import ReactGA from 'react-ga';
import {Container, Box, CircularProgress} from '@material-ui/core';
import Header from './components/Header'
import Footer from './components/Footer'
import HomeIcon from '@material-ui/icons/Home';
import BuildIcon from '@material-ui/icons/Build';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import ContactMailIcon from '@material-ui/icons/ContactMail';

const menuItems = [
  {
    name: "Home",
    path: "/",
    icon: <HomeIcon />
  },
  {
    name: "Services",
    path: "/services",
    icon: <BuildIcon />
  },
  {
    name: "About",
    path: "/about-us",
    icon: <InfoOutlinedIcon />
  },
  {
    name: "Contact",
    path: "/contact-us",
    icon: <ContactMailIcon />
  }
]

ReactGA.initialize('UA-173247143-1', {
  // debug: true,
  gaOptions: {
    siteSpeedSampleRate: 100,
    // userId: 123
  }
});

const Home = lazy(() => import('./pages/Home'))
const Services = lazy(() => import('./pages/Services'))
const About = lazy(() => import('./pages/About'))
const Contact = lazy(() => import('./pages/Contact'))

function App() {
  return (
    <div>
      <Header links={menuItems}/>
      <Container maxWidth="lg"
        component={Box}
        display="flex"
        mt={{xs: 10, sm: 11, md: 13}}
        mb={{xs: 3, sm: 4, md: 5}}
      >
        <Suspense fallback={
          <div style={{width: '100%', height: '60vh', textAlign: 'center', lineHeight: '60vh'}}>
            <CircularProgress/>
          </div>}
        >
          <Switch>
            <Route exact path="/">
              <Home/>
            </Route>
            <Route path="/services">
              <Services/>
            </Route>
            <Route path="/about-us">
              <About/>
            </Route>
            <Route path="/contact-us">
              <Contact/>
            </Route>
          </Switch>
        </Suspense>
      </Container>
      <Footer links={menuItems}/>
    </div>
  );
}

export default App;
